import { Component, Input, OnInit } from '@angular/core';
// services
import { ErrorHandler } from "../../../services/error-handler.service";
// models
import { AppState } from "../../../../booking/models/app-state.interface";
import { ModalData } from "../../../models/modal.interface";
// ngrx store
import { Store } from "@ngrx/store";
@Component({
  selector: 'app-hubdrop-info',
  templateUrl: './hubdrop-info.component.html',
  styleUrls: ['./hubdrop-info.component.scss']
})
export class HubdropInfoComponent implements OnInit {
  @Input()
  modalData: ModalData;
    @Input() appCopy;
  @Input() selectedLanguage;

  public modalList: Array<any> = [];

  constructor(
    private _errorService: ErrorHandler,
    public appStore: Store<AppState>,
  ) {}

  ngOnInit() {
    
  }

    close(event) {
    this._errorService.modalItem$.next("remove");
  }
}
